import { render, staticRenderFns } from "./JournalHistory.vue?vue&type=template&id=46993d4a&scoped=true&"
import script from "./JournalHistory.vue?vue&type=script&lang=js&"
export * from "./JournalHistory.vue?vue&type=script&lang=js&"
import style0 from "./JournalHistory.vue?vue&type=style&index=0&id=46993d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46993d4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VIcon,VProgressCircular})
